import axios from "axios";
import CreateAddEquipmentAmendmentAction from "./CreateAddEquipmentAmendmentAction";
import CreateAddVesselEquipmentDetailsAction from "./CreateAddVesselEquipmentDetailsAction";
import { POST } from "../adapters/xhr";

// import authService from "../../components/api-authorization/AuthorizeService";

export default function (licenceApplicationId, equipmentTypeCategoryId) {
    return async (dispatch, getState) => {

        try {
            const response = await axios({
                method: "GET",
                url: "api/Equipment/CheckAddEquipmentForLicenceAmendment",
                params: { licenceApplicationId, equipmentTypeCategoryId },
                withCredentials: true
            });

            dispatch({
                type: "LICENCE_AMENDMENT",
                data: response.data
            });
            
            if (response.data) {
                //create equipment amendment
                dispatch(CreateAddEquipmentAmendmentAction(licenceApplicationId));
                
                // Create payment record synchronously for amendments during reviews
                // Get amendment price from pricing configuration...
                //Please work....
                const state = getState();
                const amendmentPaymentDetail = state.availablePricings.find(p => p.id === 3); // AmendLicence = 3
                const amendmentPaymentAmount = Number(amendmentPaymentDetail?.price) || 0;
                
                if (amendmentPaymentAmount > 0) {
                    const paymentModel = {
                        id: 0,
                        transId: null,
                        licenceApplicationId: Number(licenceApplicationId) || 0,
                        paymentAmount: amendmentPaymentAmount,
                        created: new Date(),
                        createdBy: ""
                    };
                    
                    try {
                        const paymentResponse = await POST("api/LicenceApplication/NewLicencePayment", paymentModel);
                        if (paymentResponse.status === 200) {
                            dispatch({
                                type: "LICENCE_PAYMENT_RETRIEVED",
                                data: paymentResponse.data.licencePayment
                            });
                        } else {
                            console.error(`Payment creation failed with status ${paymentResponse.status}`);
                        }
                    } catch (paymentError) {
                        console.error('Payment creation failed:', paymentError);
                        // Payment creation failed, but continue with the equipment action
                    }
                } else {
                    console.warn('No amendment pricing found in configuration');
                }

            } else {
                //create equipment
                dispatch(CreateAddVesselEquipmentDetailsAction());
            }
        } catch (error) {
            console.error("CreateCheckAddEquipmentForAmendmentAction: Error", error);
        }
    };
}
